module.exports = __webpack_public_path__ + "static/media/arrows.6929b756.svg";